import type { FC } from "react";
import { Flex, Text, ValueParser } from "@huub-web/ui";

export type FinancingCapacityProps = {
  requiredAmountLabel: string;
  maximumCapacityLabel: string;
  requiredAmount: number;
  maximumCapacity: number;
};

export const FinancingCapacity: FC<FinancingCapacityProps> = ({
  requiredAmountLabel,
  maximumCapacityLabel,
  requiredAmount,
  maximumCapacity,
}) => (
  <Flex direction="row" gap="xxs" align="flex-end" wrap>
    <Flex direction="column" gap="xxs">
      <Text variant="bodyS" bold>
        {requiredAmountLabel}
      </Text>
      <Text variant="displayM" bold>
        <ValueParser value={{ type: "money", value: requiredAmount }} />
      </Text>
    </Flex>
    <Text variant="displayM" color="currentColor50">
      /
    </Text>
    <Flex direction="column" gap="xxs">
      <Text variant="bodyS" color="currentColor50" bold>
        {maximumCapacityLabel}
      </Text>
      <Text variant="displayM" bold color="currentColor50">
        <ValueParser value={{ type: "money", value: maximumCapacity }} />
      </Text>
    </Flex>
  </Flex>
);
